"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimulatorNavigation = exports.HintPosition = void 0;
var HintPosition;
(function (HintPosition) {
    HintPosition["TOP"] = "top-start";
    HintPosition["RIGHT"] = "right-start";
    HintPosition["BOTTOM"] = "bottom-start";
    HintPosition["LEFT"] = "left-start";
})(HintPosition || (exports.HintPosition = HintPosition = {}));
var SimulatorNavigation;
(function (SimulatorNavigation) {
    SimulatorNavigation["FLEX_START"] = "flex-start";
    SimulatorNavigation["FLEX_END"] = "flex-end";
    SimulatorNavigation["CENTER"] = "center";
    SimulatorNavigation["NONE"] = "none";
})(SimulatorNavigation || (exports.SimulatorNavigation = SimulatorNavigation = {}));
